export const auth = {
  // Login
  login: 'Log Masuk',
  loginTitle: 'Selamat Kembali',
  loginSubtitle: 'Log masuk ke akaun anda',
  email: 'E-mel',
  password: 'Kata Laluan',
  forgotPassword: 'Lupa Kata Laluan?',
  noAccount: 'Tiada akaun?',
  signUp: 'Daftar',
  loginButton: 'Log Masuk',
  loggingIn: 'Memasuki...',
  
  // Register
  register: 'Daftar',
  registerTitle: 'Cipta Akaun',
  registerSubtitle: 'Sertai MakanTak hari ini',
  fullName: 'Nama Penuh',
  confirmPassword: 'Sahkan Kata Laluan',
  haveAccount: 'Sudah mempunyai akaun?',
  signIn: 'Log Masuk',
  registerButton: 'Cipta Akaun',
  registering: 'Mencipta akaun...',
  agreeToTerms: 'Dengan mendaftar, anda bersetuju dengan',
  termsOfService: 'Terma Perkhidmatan',
  and: 'dan',
  privacyPolicy: 'Dasar Privasi',
  
  // Forgot Password
  forgotPasswordTitle: 'Set Semula Kata Laluan',
  forgotPasswordSubtitle: 'Masukkan e-mel anda untuk menerima arahan set semula',
  sendResetLink: 'Hantar Pautan Set Semula',
  sending: 'Menghantar...',
  backToLogin: 'Kembali ke Log Masuk',
  resetEmailSent: 'E-mel set semula dihantar! Semak peti masuk anda.',
  
  // Reset Password
  resetPasswordTitle: 'Tetapkan Kata Laluan Baharu',
  resetPasswordSubtitle: 'Masukkan kata laluan baharu anda',
  newPassword: 'Kata Laluan Baharu',
  resetPasswordButton: 'Set Semula Kata Laluan',
  resetting: 'Menetapkan semula...',
  passwordResetSuccess: 'Kata laluan berjaya ditetapkan semula!',
  
  // Validation
  emailRequired: 'E-mel diperlukan',
  passwordRequired: 'Kata laluan diperlukan',
  nameRequired: 'Nama penuh diperlukan',
  passwordsNotMatch: 'Kata laluan tidak sepadan',
  invalidEmail: 'Alamat e-mel tidak sah',
  passwordTooShort: 'Kata laluan mestilah sekurang-kurangnya 6 aksara',
};
